export default __webpack_public_path__ + "static/media/DSC_0707.36712c50.JPG";